let getInstance;

const axiosProvider = {
  /**
   * Initialize the `axiosProvider` with a method to retrieve an axios instance.
   * Init cannot be run multiple times.
   * @param {function} initGetInstance
   */
  init: initGetInstance => {
    const isGetInstanceFunction = typeof getInstance === "function";
    const isInitGetInstanceFunction = typeof initGetInstance === "function";

    if (!isGetInstanceFunction && isInitGetInstanceFunction) {
      getInstance = initGetInstance;
    } else if (!isGetInstanceFunction && !isInitGetInstanceFunction) {
      throw new Error("axiosProvider must be initialized with a function");
    } else {
      throw new Error("axiosProvider is already initialized");
    }
  },
  /**
   * Get the axios instance from the method `axiosProvider` was initialized with.
   * @returns {object} axios
   */
  getInstance: () => {
    if (typeof getInstance === "function") {
      return getInstance();
    } else {
      throw new Error("axiosProvider is not initialized");
    }
  }
};

module.exports = axiosProvider;
